<template>
<div class="page page_lives">
	<van-tabs v-model="active" swipe-threshold="6" @click="onTabsClick">
        <van-tab title="全部" :name="0"></van-tab>
        <van-tab title="待支付" :name="1"></van-tab>
        <van-tab title="待核销" :name="2"></van-tab>
        <van-tab title="已核销" :name="3"></van-tab>
        <van-tab title="已关闭" :name="4"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div class="list">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadorder" :immediate-check="false">
                <div class="item item-lives" v-for="(item, key) in orderlist" :key="key" @click="toDetail(item.id)">
					<div class="item-shop">
						<div class="shop-info">
							<img :src="item.tradesman.thumb ? ($publicData.withHttpStart(item.tradesman.thumb) ? item.tradesman.thumb : imageUrl+item.tradesman.thumb ) : $publicData.defaultTouxiang" alt="" class="shop-thumb">
							<div class="shop-name">{{ item.tradesman.nickname }}</div>
						</div>
						<div class="item-status" v-if="item.status == 0">已取消</div>
						<div class="item-status" v-if="item.status == 1 && item.pay_status != 2">待支付</div>
						<div class="item-status" v-if="item.status == 1 && item.pay_status == 2 && item.fx_status != 1">待核销</div>
						<div class="item-status" v-if="item.status == 1 && item.pay_status == 2 && item.fx_status == 1">已核销</div>
					</div>
                    <div class="item_t clearfix">
                        <van-image class="f-l item_t_l" fit="contain" v-if="item.orderphoto" :src=" item.orderphoto.live_thumb ? imageUrl+item.orderphoto.live_thumb : publicPath + 'statics/images/temp/ordertu.png' " />
                        <div class="f-l item_t_r">
                            <div class="title slh_s" v-if="item.orderphoto">{{ item.orderphoto.live_title }}</div>
                            <div class="sku_wrap">
                                <div class="sku clearfix">
                                    <div class="sku_l f-l">场次：</div>
                                    <div class="sku_r f-l slh" v-if="item.orderphoto">
                                        {{ item.orderphoto.ticket_field_title }}
                                    </div>
                                </div>
                                <!-- <div class="sku clearfix">
                                    <div class="sku_l f-l">门票：</div>
                                    <div class="sku_r f-l slh_s">{{ item.mark }}</div>
                                </div> -->
                                <div class="sku clearfix">
                                    <div class="sku_l f-l">单价：</div>
                                    <div class="sku_r f-l">
                                        <!-- <span class="price"><span class="tag_cash">¥</span>{{ Math.round(parseFloat(item.price) * 10) / 10 }}</span> -->
                                        <span class="price"><span class="tag_cash">¥</span>{{ item.price }}</span>
                                    </div>
                                </div>
								<div class="sku clearfix">
                                    <div class="sku_l f-l">开场时间：</div>
                                    <div class="sku_r f-l slh_s" v-if="item.orderphoto">
										<div class="">{{ item.orderphoto.field_date_at }}</div>
										<div class="">{{ item.orderphoto.field_time_at }}</div>
                                    </div>
                                </div>
								<div class="sku clearfix">
                                    <div class="sku_l f-l">下单时间：</div>
                                    <div class="sku_r f-l">
                                        {{ item.created_at }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item_b">
                        <div class="zongji">
                            <span class="zongji_l">共{{ item.nums }}张票</span>
                            <!-- <span class="zongji_r">合计：<span class="price"><span class="tag_cash">¥</span>{{
                        Math.round(parseFloat(item.total_prices) * 10) / 10
                    }}</span></span> -->
                            <span class="zongji_r">合计：<span class="price"><span class="tag_cash">¥</span>{{item.total_prices}}</span></span>
                        </div>
                        <div class="actions">
                            <!-- <div class="action" @click.stop="showDetail(item)">查看详情</div> -->
                            <div class="action" v-if="item.pay_status == 0 && item.status == 1 || item.pay_status == 1 && item.status == 1" @click.stop="toBuy(item)">支付</div>
							<div class="action" v-if="item.status == 1 && item.is_quxiao == 1" @click.stop="cancelOrder(item)">取消订单</div>
						</div>
                    </div>
                </div>
            </van-list>
        </div>
    </van-pull-refresh>
    <!-- 订单详情 -->
    <van-popup v-model="showDetailStatus" round position="bottom" class="addPop" close-icon="close" :closeable="true">
        <div class="pop_title">订单详情</div>
		<div class="hexiao-code">
			<!-- margin-left: 2.4rem;
					width: 4rem;
					text-align: center; -->
			<img :src="publicPath+'/statics/images/temp/qrcode.png'" alt="" class="code-tu">
			<div class="tips">核销码，请给商家扫码</div>
		</div>
        <div class="pop_nr yuekan_order_detial" v-if="detail != null">
            <!-- <van-field label="名称" :value="detail.live.title" readonly /> -->
            <div class="address">
                <div class="address_title">名称</div>
                <div class="address_txt">{{detail.live.title}}</div>
            </div>
            <!-- <van-field label="状态" :value="detail.status == 1  ? '支付中': detail.status == 2 ? '已完成': '未支付' " readonly /> -->
            <van-field label="状态" :value="detail.status == 1 ? (detail.pay_status == 1  ? '支付中': detail.pay_status == 2 ? '已完成': '未支付') :'已取消' " readonly />
            <!-- <van-field label="活动地址" :value="detail.live.address" readonly /> -->
            <div class="address">
                <div class="address_title">活动地址</div>
                <div class="address_txt">{{detail.live.address}}</div>
            </div>
            <van-field label="活动时间" :value="detail.live.starttime" readonly />
            <van-field label="购买票数" :value="detail.nums" readonly />
            <div class="tickets">
                <van-cell-group v-for="(titem,tkey) in detail.data" :key="tkey">
                    <van-field label="门票信息" :value="titem.ticket_datas.tickets.title" readonly />
                    <van-field label="票号信息" :value="titem.ticket_datas.ticket_num" readonly />
                </van-cell-group>
            </div>
            <van-field label="场次信息" v-if="detail.ticket_field" :value="detail.ticket_field.title" readonly />
            <van-field label="开场时间" v-if="detail.ticket_field" :value="detail.ticket_field.date_at + ' ' + detail.ticket_field.time_at" readonly />
            <van-field label="订单编号" :value="detail.order_num" readonly />
            <van-field label="下单时间" :value="detail.created_at" readonly />
            <van-field label="联系电话" :value="detail.trad_phone" readonly />
        </div>
    </van-popup>
</div>
</template>

<script>
import {
    Toast
} from 'vant'
import Vue from "vue";
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            orderlist: [], // 订单列表
            pages: {
                page: 1,
                size: 10,
            },
            refreshing: false, // 下拉刷新
            loading: true,
            finished: false,
            loadData: false, // 是否在请求数据
            detail: null, //  详情
            showDetailStatus: false, // 详情弹窗状态
            token: '',
			active: 0 // 0全部 1未支付 2已支付未核销 3已核销 4已关闭
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    naviTitle: '约看订单',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        this.onRefresh()
                    } else {
                        this.token = "";
                    }
                }
            );
        } else {
            this.token = this.$store.getters.token;
            this.onRefresh()
        }
        this.pages.page = 1;
        this.finished = false;
        this.loading = true;
        this.loadData = false;
    },
    methods: {
		onTabsClick(){
			this.pages.page = 1;
            this.orderlist = [];
            this.loading = true;
            this.loadorder();
		},
        onRefresh() {
            this.pages.page = 1;
            this.orderlist = [];
            this.loading = true;
            this.loadorder();
        },
        // 获取列表
        loadorder() {
            var token = this.token;
            var param = {
                page: this.pages.page,
                size: this.pages.size,
                token: this.token,
            };
			if(this.active){
				param.status = this.active;
			};
            // console.log(this.loading);
            if (this.loadData) {
                return;
            }
            this.loadData = true;
            this.$api.live.liveorderlist(param).then((res) => {
                this.orderlist.push.apply(this.orderlist, res.result.list);
                this.loading = false;
                this.loadData = false;
                this.pages.page += 1;
                // console.log('this.orderlist', this.orderlist);
                if (res.result.list.length < this.pages.size) {
					this.finished = true;
					this.refreshing = false
                }
            });
        },
        showDetail(item) {
            this.detail = null;
            this.detail = item;
            // console.log('item',item)
            let info = JSON.parse(item.enterinfo.info);
            for (var i in info) {
                // console.log(info[i])
                for (var j in info[0]) {
                    if (j == 'phone') {
                        this.detail.phone = info[i][j];
                        break;
                    }
                }
            }
            this.showDetailStatus = true;
        },
        // 购买
        toBuy(item) {
            // console.log('item',item)
            this.$router.push({
                path: '/yuekan/pay',
                query: {
                    orderId: item.order_num,
                    price: item.total_prices,
					is_chargecard: item.orderphoto.is_chargecard
                }
            })
		},
		// 取消订单
		cancelOrder(item){
			var that = this
			var params = {
				token: that.token,
				order_id: item.id
			}
			that.$api.live.cancelLive(params).then(res=>{
				if(res.code == 200){
					that.$toast(res.message);
					that.onRefresh();
				}else if(res.code == 201){
					Toast.loading({
						type: 'html',
						duration: 3000,
						message: res.message,
						forbidClick: true
					});
					that.onRefresh();
				}
			})
		},
		/**
		 * @name: 跳转订单详情
		 * @param {*} id
		 * @return {*}
		 * @desc: 
		 */		
		toDetail(id){
			this.$router.push({
				path: '/yuekan/order/detail',
				query: {
					id: id
				}
			})
		}
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.sku_wrap {
    position: relative;
    width: 5.6rem;
    overflow: hidden;
}

.page_lives .item_t .sku_r {
    width: 3.6rem;
}

.page .item {
    padding-top: 0.43rem;
}

/deep/.address {
    display: flex;
}

/deep/.address .address_title {
    width: 2.5rem;
    font-size: .32rem;
    color: #323233;
}

/deep/.address .address_txt {
    width: 7rem;
    padding-left: .3rem;
}
</style>
